<template>
  <div>
    <div class="thankyou-page" v-if="invoice">
      <div class="container">
        <h1 class="text-center text-primary ">ขอบคุณสำหรับการบริจาค</h1>
        <h2 class="text-center">และร่วมเป็นส่วนหนึ่งในการช่วยแก้ปัญหา<br class="d-none d-md-block" />ความเหลื่อมล้ำทางการศึกษาไทย</h2>
        <!-- <h1 class="text-primary text-center">ขอบคุณสำหรับการบริจาค</h1>
        <h4 class="mb-2 text-center">กับโครงการ <br class="d-block d-sm-none"><span class="text-primary">#สู้วิกฤตให้น้องอิ่ม</span> <br class="d-block d-sm-none">โดยกสศ.</h4>
        <h5 class="text-center">คุณได้ร่วมเติมเต็มมื้ออาหารให้เด็ก ๆ <br class="d-none d-md-block">ให้พวกเขาสามารถก้าวผ่านวิกฤตและมีโอกาส<br>กลับมาเรียนอีกครั้ง เมื่อเปิดเทอมใหม่มาถึง</h5> -->
        <br />
        <div class="text-center thankyou-remark" v-if="showBankTransferInfo">
          <h3>ช่องทางการโอนเงิน</h3>
          <p><img class="mr-1" src="/static/img/thaibank/ktb.png" height="20" />ธนาคารกรุงไทย<br /> สาขา ซอยอารีย์ (ออมทรัพย์) <br />ชื่อบัญชี: กสศ.มาตรา 6(6) - เงินบริจาค<br />เลขบัญชี 172-0-30021-6</p>
        </div><br v-if="showBankTransferInfo" />
        <!-- <div class="flex-center block-social-share">
          <span>ชวนเพื่อนมาร่วมบริจาค</span>
          <vue-goodshare-facebook
                  :page_url="$config.MAIN_WEBSITE_URL"
                  title_social="Facebook"
                  has_icon />
          <share-line-button
                  :page_url="$config.MAIN_WEBSITE_URL"
                  title_social="Line"
                  has_icon />
        </div> -->
        <!-- <a href=""><img class="img-responsive" src="../../../assets/img/btn-fb-share.png" alt="Facebook Share" /></a>
        <a href=""><img class="img-responsive" src="../../../assets/img/btn-line-share.png" alt="Line Share" /></a> -->
        <div v-if="showUploadSlipForm">
          <div class="text-center thankyou-remark bg-light">
            <p>กรุณายืนยันการโอนเงิน จากแบบฟอร์มด้านล่าง<br class="d-none d-md-block" />หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</p>
            <p>ผู้บริจาคต้องแนบหลักฐานการโอนเงินภายใน 3 วันหลังจากทำรายการสำเร็จ</p>
          </div>
        </div>

        <div v-if="!showUploadSlipForm">
          <div class="text-center thankyou-remark">
            <p>อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา</p>
          </div>

          <!--<div class="block text-center mt-30"><a :href="backUrl" class="btn btn&#45;&#45;white btn-md">กลับไปหน้าแรก</a></div>-->
        </div>

      </div> <!--  -->
    </div> <!-- /thankyou-page -->

    <!-- note - เช็คสั่งจ่าย -->
    <div class="show-note" v-if="showChequeInfo">
      <div class="">
        <div class="container">
          <div class="block-primary block shadow radius mb-15 mt-15">
            <h2 class="text-center mb-20">การบริจาคผ่านเช็คสั่งจ่าย</h2>
            <div class="form__item pd-15">
              <div class="show-note-item">
                <strong>1. เช็คสั่งจ่าย</strong>
                <div class="indent">มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา</div>
              </div>
              <div class="show-note-item">
                <strong>2. จัดส่งเช็คตัวจริงมาตามที่อยู่ด้านล่างนี้</strong>
                <div class="indent">
                ฝ่ายบัญชี<br />
                มูลนิธิยุวพัฒน์<br />
                1 อาคารพรีเมียร์คอร์เปอเรทปาร์ค ถนนศรีนครินทร์ แขวงหนองบอน เขตประเวศ กรุงเทพ 10250
              </div>
              </div>
            </div>
            <p class="mw-600">เมื่อเจ้าหน้าที่ตรวจสอบความถูกต้องแล้ว ผู้บริจาคจะได้รับอีเมลยืนยันอีกครั้ง จึงจะถือว่าการบริจาค
เสร็จสมบูรณ์</p>
          </div>
        </div>
      </div>
    </div>


    <div class="show-uploadslip" v-if="showUploadSlipForm">
      <upload-slip />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import UploadSlip from '@/components/UploadSlip'
  import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook'
  import ShareLineButton from '../../ShareLineButton'

  export default {
    name: 'ThankYouBase',

    components: {
      UploadSlip,
      VueGoodshareFacebook,
      ShareLineButton
    },

    props: {
      invoice: {
        type: Object,
        default: null
      }
    },

    computed: {
      showBankTransferInfo () {
        return !this.invoice || this.invoice.payment_method === 'bank_transfer'
      },
      showUploadSlipForm () {
        return this.invoice && this.invoice.payment_method === 'bank_transfer'
      },
      showChequeInfo () {
        return this.invoice && this.invoice.payment_method === 'cheque'
      },
      backUrl () {
        return Vue.config.MAIN_WEBSITE_URL
      }
    }
  }
</script>

<style scoped lang="scss">
  .thankyou-page {
    background: #A1D4E3 url('../../../assets/img/bg-thankyou-full.jpg') no-repeat top center;
    background-size: cover;
    color: #153050;
    font-size: 17px;
    position: relative;
    padding: 5rem 0;
    min-height: 600px;
    

    p {  margin: 0; }
    h1 {
      color: #153050;
      font-weight: 400;
      font-size: 1.75em;
      line-height: 1.4em;
    }
    h2 { font-size: 1.2em; }
    h2, h3, h4 {
      color: #153050;
      font-weight: 300;
    }
    .container {
      max-width: 1200px;
      margin: 0 auto;
    }
    .block-social-share {
      z-index: 1;
      margin: 40px 0;
      img { padding-left: 5px; }
      a { z-index: 1; color: #fff; }
    }
    .thankyou-banner {
      position: relative;
      margin-top: -2.5em;
      text-align: center;
    }
    .thankyou-remark {
      position: relative;
      max-width: 350px;
      background: #fff;
      font-size: 80%;
      padding: 10px;
      margin: 1em auto;
      border-radius:  5px;
    }
    @media all and (max-width: 767px) {
      h1 { font-size: 1.3em; padding: 10px 5px 0;}
      h2 { font-size: 1.1em; }
      p { padding: 0 10px; }
      .block-image-share {
        margin: 10px 0;
        padding: 10px 10px 5px;
        text-align: center;
        background-size: cover;
      }
      .thankyou-remark {
        font-size: 0.85em;
      }
      .thankyou-banner {
        margin: 0;
      }
    }
    @media all and (max-width: 500px) {
      &:before {
        background: none;
      }
      .thankyou-remark {
        font-size: 0.85em;
        max-width: 400px;
      }
    }
    @media all and (max-width: 400px) {
      .block-social-share {
        margin: 20px 0;
        font-size: 0.85em;
        line-height: 1.1em;
      }
    }
  }

  .show-uploadslip .header-wrapper {
    padding: 0;
    background: #fff;
  }

  .block-social-share >>> .button-social {
    margin: 0 5px;
    padding: 5px 7px;
    font-size: 14px;
    line-height: 1.2;
  }

//show note
.show-note {
  background: #fff url("../../../assets/img/bg-line01.png") no-repeat top center;
  background-size: 100%;
  padding: 50px 0;
  @media all and (max-width: 768px) {
    padding: 20px 0;
  }
  .block {
    max-width: 800px;
    margin: 0 auto;
  }
  .form__item {
    margin: 0 auto;
    max-width: 600px;
  }
  .show-note-item {
    margin-bottom: 1.5em;
    &:last-child { margin: 0;}
  }
  .mw-600 {
   max-width: 600px;
   margin: 1em auto;
 }
 .indent {
   padding-left: 18px;
   padding-top: 5px;
 }
}
.bg-light { background: rgba(255, 255, 255, 0.75) !important; }

.text-primary { color: #38AB49 !important; }
</style>



// WEBPACK FOOTER //
// base.vue?28f7ca5e